import script from "./LeagueRoundMatchesTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeagueRoundMatchesTable.vue?vue&type=script&lang=ts&setup=true"

import "./LeagueRoundMatchesTable.vue?vue&type=style&index=0&id=8004ecb2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8004ecb2"]])

export default __exports__